import {Area, AreaChart, ResponsiveContainer} from 'recharts';
import {useState} from 'react';
import {getQualities, getThumbnailURL} from '../../util/videoUtil';
import {VideoFlags} from '../../shared/bitsets';
import {isHLSProvider, MediaPlayer, MediaProvider} from '@vidstack/react';
import HLS from 'hls.js';
import {defaultLayoutIcons, DefaultVideoLayout} from '@vidstack/react/player/layouts/default';
import {getAPIBaseUrl} from '../../API';
import experiments from '../../shared/experiments';
import {useSelector} from 'react-redux';

export default function CHPlayer({video, engagement, videoEngagement}) {
    const [videoProgress, setVideoProgress] = useState(0);
    const user = useSelector((state) => state.user);

    let yt = video.yt_id && experiments['2024_10_15_YouTube_embed'].getValue(user, null);

    let qualities = getQualities(video);
    qualities.reverse();

    let progressPercentage = `${videoProgress / video.length * 100}%`;

    return <MediaPlayer
        className="media-player"
        crossOrigin
        playsInline
        src={
            yt ? `youtube/${video.yt_id}` :
                ((video.flags & VideoFlags.SupportsPartials) !== 0 ?
                    {src: `${getAPIBaseUrl()}/video/${video.link_id}/hls`, type: 'video/x-mpegurl'} :
                    {
                        src: `https://cornhub.objectdepot.net/video/${video.link_id}/${qualities[0]}.mp4`,
                        type: 'video/mp4'
                    })
        }
        onProviderChange={(provider) => {
            if (isHLSProvider(provider)) {
                provider.library = HLS;
            }
        }}
        onTimeUpdate={(event) => {
            engagement.current.data[Math.ceil(event.currentTime) - 1]++;
            let sec = Math.floor(Date.now() / 1000);
            if (engagement.current.lastSec !== sec) {
                engagement.current.lastSec = sec;
                engagement.current.secs++;
            }
            setVideoProgress(event.currentTime * 1000);
        }}
    >
        <MediaProvider/>
        <div className="vds-controls" data-visible={true}>
            <div className="vds-controls-spacer"/>
            <div className="vds-controls-group pointer-events-none chartcontainer">
                <div className="chart-pad"/>
                <ResponsiveContainer width="100%" height={30} className="pointer-events-none chart">
                    <AreaChart data={videoEngagement} connectNulls={true}>
                        <defs>
                            <linearGradient id="colorGraph" x1="0" y1="0" x2="1" y2="0">
                                <stop offset="0%" stopColor="#fff" stopOpacity={0.7}/>
                                <stop offset={progressPercentage} stopColor="#fff" stopOpacity={0.7}/>
                                <stop offset={progressPercentage} stopColor="#211D1B" stopOpacity={0.58}/>
                                <stop offset="100%" stopColor="#211D1B" stopOpacity={0.58}/>
                            </linearGradient>
                        </defs>
                        <Area type="monotone" dataKey="data" stroke="url(#colorGraph)" fillOpacity={0.58}
                              fill="url(#colorGraph)" isAnimationActive={false}/>
                    </AreaChart>
                </ResponsiveContainer>
                <div className="chart-pad"/>
            </div>
        </div>
        <DefaultVideoLayout
            thumbnails={getThumbnailURL(video)}
            icons={defaultLayoutIcons}/>
    </MediaPlayer>;
}
